const PerfVersion = () => import(/* webpackChunkName: "perf" */ '@/components/perf/Version');

const PerfAwardLevel = () => import(/* webpackChunkName: "perf" */ '@/components/perf/awardLevel');
const PerfIntellPropertyLevel = () => import(/* webpackChunkName: "perf" */ '@/components/perf/intellPropertyLevel');
const PerfPaperLevel = () => import(/* webpackChunkName: "perf" */ '@/components/perf/paperLevel');
const PerfProjectLevel = () => import(/* webpackChunkName: "perf" */ '@/components/perf/projectLevel');
const PerfRegistrationLevel = () => import(/* webpackChunkName: "perf" */ '@/components/perf/registrationLevel');

const PerfAwardLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/awardLevelScore');
const PerfBookLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/bookLevelScore');
const PerfIntellPropertyLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/intellPropertyLevelScore');
const PerfJournalLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/journalLevelScore');
const PerfConferenceLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/conferenceLevelScore');
const PerfProjectLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/projectLevelScore');
const PerfEduProjectLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/eduProjectLevelScore');
const PerfRegistrationLevelScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/registrationLevelScore');

const PerfBatch = () => import(/* webpackChunkName: "perf" */ '@/components/perf/batch');
const perfProjectScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/projectScore');
const perfPaperScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/paperScore');
const PerfBookScore = () => import(/* webpackChunkName: "perf" */ '@/components/perf/bookScore');
export default {
  routes: [
    {
      path: '/perf/Version',
      name: 'perf_version',
      component: PerfVersion
    },{
      path: '/perf/awardLevel',
      name: 'perf_awardLevel',
      component: PerfAwardLevel
    }, {
      path: '/perf/intellPropertyLevel',
      name: 'perf_intellPropertyLevel',
      component: PerfIntellPropertyLevel
    }, {
      path: '/perf/paperLevel',
      name: 'perf_paperLevel',
      component: PerfPaperLevel
    }, {
      path: '/perf/projectLevel',
      name: 'perf_projectLevel',
      component: PerfProjectLevel
    }, {
      path: '/perf/registrationLevel',
      name: 'perf_registrationLevel',
      component: PerfRegistrationLevel
    },{
      path: '/perf/awardLevelScore',
      name: 'perf_awardLevelScore',
      component: PerfAwardLevelScore
    }, {
      path: '/perf/bookLevelScore',
      name: 'perf_bookLevelScore',
      component: PerfBookLevelScore
    }, {
      path: '/perf/intellPropertyLevelScore',
      name: 'perf_intellPropertyLevelScore',
      component: PerfIntellPropertyLevelScore
    }, {
      path: '/perf/journalLevelScore',
      name: 'perf_journalLevelScore',
      component: PerfJournalLevelScore
    }, {
      path: '/perf/conferenceLevelScore',
      name: 'perf_conferenceLevelScore',
      component: PerfConferenceLevelScore
    }, {
      path: '/perf/projectLevelScore',
      name: 'perf_projectLevelScore',
      component: PerfProjectLevelScore
    },{
      path: '/perf/eduProjectLevelScore',
      name: 'perf_eduProjectLevelScore',
      component: PerfEduProjectLevelScore
    }, {
      path: '/perf/registrationLevelScore',
      name: 'perf_registrationLevelScore',
      component: PerfRegistrationLevelScore
    }, {
      path: '/perf/batch',
      name: 'perf_batch',
      component: PerfBatch
    }, {
      path: '/perf/projectScore',
      name: 'perf_projectScore',
      component: perfProjectScore
    }, {
      path: '/perf/paperScore',
      name: 'perf_paperScore',
      component: perfPaperScore
    }, {
      path: '/perf/bookScore',
      name: 'perf_bookScore',
      component: PerfBookScore
    }
  ]
}
